import React, { useState, useRef, useEffect } from "react";

// 👉 1. Added formData to props
export default function FinalOTPStep({ setCurrentStep, selectedOffer, formData }) {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timeLeft, setTimeLeft] = useState(58);
  const inputRefs = useRef([]);

  // 👉 2. Safely extract and format the mobile number from formData or localStorage
  const rawMobile = formData?.mobile || localStorage.getItem("mobile") || "0000000000"; 
  
  // Mask the first 6 digits and show the last 4
  const maskedMobile = rawMobile.length >= 10 
    ? `XXXXXX${rawMobile.slice(-4)}` 
    : "XXXXXX0000";

  // Countdown timer logic
  useEffect(() => {
    if (timeLeft > 0) {
      const timerId = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timerId);
    }
  }, [timeLeft]);

  const handleOtpChange = (index, e) => {
    const value = e.target.value.replace(/[^0-9]/g, ""); // Allow only numbers
    if (!value && e.target.value !== "") return;

    const newOtp = [...otp];
    newOtp[index] = value.substring(value.length - 1); 
    setOtp(newOtp);

    // Auto-focus next input
    if (value !== "" && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleOtpKeyDown = (index, e) => {
    // Auto-focus previous input on backspace
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleSubmit = () => {
    const otpValue = otp.join("");
    console.log("Verifying Final OTP:", otpValue);
    if (otpValue.length === 6) {
      setCurrentStep(18); 
    }
  };

  const lenderName = selectedOffer?.lender_name || "CredFin";

  return (
    <div className="w-full max-w-[400px] mx-auto bg-white min-h-[100dvh] font-atkinson flex flex-col relative pb-[100px]">
      
      {/* Header & Progress Bar */}
      <div className="px-5 pt-6 pb-4 border-b border-transparent">
        <div className="flex justify-center mb-4">
          <div className="text-center leading-none">
            <h1 className="text-[#205A6D] font-bold text-[22px] tracking-tight">
              {lenderName}
            </h1>
          </div>
        </div>
        
        <div className="flex items-center justify-between">
          <button onClick={() => setCurrentStep(16)} className="w-6 h-6 flex items-center justify-start text-gray-700">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
          </button>
          
          <div className="flex-1 mx-4 h-[4px] bg-[#e6f4ed] rounded-full overflow-hidden">
            <div className="h-full bg-[#12f280] w-[98%] rounded-full"></div>
          </div>
          <span className="text-[12px] text-gray-500 font-medium">98%</span>
        </div>
      </div>

      {/* Main Content */}
      <div className="px-5 pt-2 flex-1">
        <h2 className="text-[22px] font-bold text-[#1b1b1b]">Enter OTP</h2>
        <p className="text-[13px] text-[#8b8b8b] mt-2 mb-8 leading-relaxed">
          Please enter the 6-digit OTP that has been sent to your registered mobile number.
        </p>

        {/* 👉 3. Render the dynamically masked mobile number */}
        <p className="text-[14px] text-[#555] font-medium mb-4">
          OTP sent to +91 {maskedMobile}
        </p>

        {/* 6-Digit OTP Inputs */}
        <div className="flex justify-between gap-2 mb-10">
          {otp.map((digit, index) => (
            <input
              key={index}
              ref={(el) => (inputRefs.current[index] = el)}
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength="1"
              className="w-[45px] h-[50px] border border-[#e5e5e5] rounded-[10px] text-center text-[20px] font-bold text-[#1b1b1b] focus:border-black focus:outline-none transition-colors shadow-sm"
              value={digit}
              onChange={(e) => handleOtpChange(index, e)}
              onKeyDown={(e) => handleOtpKeyDown(index, e)}
            />
          ))}
        </div>

        {/* Resend Timer & Action Button */}
        <div className="flex flex-col items-center">
          <p className="text-[12px] text-[#8b8b8b] mb-4">
            Didn't receive the OTP?{" "}
            {timeLeft > 0 ? (
              <span className="font-bold text-[#1b1b1b]">
                Resend in 00.{timeLeft.toString().padStart(2, "0")} Sec
              </span>
            ) : (
              <button 
                onClick={() => setTimeLeft(58)} 
                className="font-bold text-[#FF7A00]"
              >
                Resend Now
              </button>
            )}
          </p>

          <button 
            onClick={handleSubmit} 
            disabled={otp.join("").length !== 6}
            className="w-full bg-black text-white font-bold text-[16px] rounded-[14px] py-[18px] active:scale-[0.98] transition-transform disabled:opacity-40 disabled:cursor-not-allowed"
          >
            Verify OTP
          </button>
        </div>
      </div>
    </div>
  );
}